import React, { useState } from 'react';
import { Text, View } from 'react-native-web';
import { select_package_layout_aligned_key } from '../../../../utils/DictionaryManagementUtils';
import ExpendArrowBtn from '../ButtonComponent/ExpendArrowBtn';

//= ========================================================================

const PackageCard = ({
  globJSON, packageObject, numberColumns, layoutAligned,
}) => {
  const { colors } = globJSON.configurations.theme;
  const [expendDetails, setExpendDetails] = useState(false);
  const makeAmountAsTitle = layoutAligned === select_package_layout_aligned_key.center_aligned;

  const myStyles = {
    card: {
      marginBottom: 10,
      flexBasis: `${100 / numberColumns - numberColumns}%`,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 4 : 9,
      border: `solid 0.6px ${colors.border_color}`,
      padding: makeAmountAsTitle ? 15 : 10,
      marginEnd: numberColumns > 1 && `${numberColumns}%`,
    },
    title: {
      fontSize: numberColumns === 3 ? 9.3 : 11.6,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },

    amount: {
      fontSize: makeAmountAsTitle ? 11.6 : 9.3,
      marginVertical: makeAmountAsTitle ? 'auto' : 0,
      marginHorizontal: layoutAligned === select_package_layout_aligned_key.center_aligned ? 'auto' : 0,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      marginTop: 5,
    },
    details: {
      fontFamily: 'SFProText',
      fontSize: 7.5,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      marginTop: 5,
      color: colors.secondary_font_color,
    },
    expendArrow: { position: 'absolute', end: 10 },
  };

  const onPress = () => {
    setExpendDetails(!expendDetails);
  };

  return (
    <View style={myStyles.card}>
      {!makeAmountAsTitle && (
        <Text style={myStyles.title}>{packageObject.title}</Text>
      )}
      <Text style={myStyles.amount}>{packageObject.amount}</Text>
      {expendDetails && <Text style={myStyles.details}>{packageObject.details}</Text>}
      {numberColumns === 1 && layoutAligned === select_package_layout_aligned_key.left_aligned && (
        <ExpendArrowBtn onPress={onPress} expendDetails={expendDetails} style={myStyles.expendArrow} />
      )}
    </View>
  );
};
export default PackageCard;
